export class GetSourceAccountMetricsConfigResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceAccountConfig",
            "baseName": "sourceAccountConfig",
            "type": "SourceAccountMetricsConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetSourceAccountMetricsConfigResponse.attributeTypeMap;
    }
    constructor() {
    }
}
